<template lang="pug">
  div.payment.accruals-legals
    e-toolbar(
      :items="items"
      :hideRemoveButton="true"
      :showTotal="true"
      :showViewPanel="false"
      :hideImportBtn="true"
      :hideAddButton="true"

      :useFilterBtn="true"
      :showFilter="showFilter"
      @closeFilterPanel="onCloseFilterPanel()"
      @openFilterPanel="onOpenFilterPanel()"
    )
      e-form-search-filter(
        slot="filter"
        :formValidator="formValidator"
        v-if="showFilter"
        @apply="applyFilter()"
        @reset="resetFilter()"
      )
        div.one-row
          e-form-group(
            formGroupStyle="filter-block"
            label="Дата создания"
            inputType="calendar"
            :model="filterModel"
            tabView="tab1"
            name="created"
            placeholder="дд.мм.гггг"
          )

          e-form-group(
            formGroupStyle="filter-block"
            label="Период"
            inputType="calendar"
            :model="filterModel"
            tabView="tab1"
            name="period"
            type="month"
            format="MM.yyyy"
            valueFormat="yyyy-MM"
            placeholder="мм.гггг"
          )

          div.filter-block

          e-form-search-filter-buttons(
            :loading="searchInProgress"
          ).filter-block

      div(slot="additionalActions")
        button(
          v-if="userCanCreate"
          @click.stop.prevent="openInvoiceCreate()"
        ).btn-add.green.actions-panel__button Сформировать

    e-table(
      :defaultColumnWidth="150"
      :items="items"
      :showCheckbox="false"
      :showDeleteButton="false"
      :showEditButton="false"
    )
      div(slot="id" slot-scope="{row}")
        router-link(
          tag="a"
          :to="{name: 'payment.accrualsLegalPacket', params: {packetId: row.id}}"
        ) {{row.id}}

    router-view
</template>

<script>
  import {payment} from '../../api/api-endpoints.js'
  import tableMixin from "../../components/table/table-mixin.js"
  import permissionMixin from '../../mixins/permission-mixin.js'

  const FilterModel = () => ({
    created: '',
    period: ''
  })

  export default {
    mixins: [tableMixin, permissionMixin],
    created () {
      if (this.items && !this.items._meta.fields.id) {
        this.$store.commit(
          'mutateError',
          new Error('В мете отсутствует id требуемое для отображения ссылки!')
        )
      }
    },
    data () {
      return {
        filterModel: new FilterModel()
      }
    },
    methods: {
      getEndpoint (route) {
        return payment.accrualsLegals(route)
      },
      openInvoiceCreate () {
        const {route, json} = this.getRoute()
        this.$router.push({name: route.name + '.create', query: {prevRoute: json}})
      }
    }
  }
</script>
